export default {
  '/KxreR': '库存准时率',
  '2MYr1m': '登录',
  '4/Lg7X': '请输入登录密码',
  '7wofGo': '应用',
  '9UZxwP': '请输入验证码',
  'AUuPe6': '至少输入{num}个字符，双击切换至批量查询',
  'BC74I9': '提示信息',
  'BG+fLq': '帮助指南',
  'CLqPBU': '编辑',
  'CMMjhY': '列展示',
  'Gwj7xc': '恢复默认',
  'I1vr0V': '找回密码',
  'J9jPRL': '复制成功',
  'MhOy8s': '至少输入{num}个字符',
  'N5Lfmq': '不允许的文件格式',
  'OQBMaY': '邮箱登录',
  'USKhsn': '搜索的 "{keyword}" 的结果',
  'UtE0dS': '操作',
  'VaYh5v': '记住密码',
  'WgC6Gs': '正在导出中, 稍后可在 “<url>导出中心</url>” 查看',
  'XeiAal': '删除',
  'Xjfb5m': '隐私政策',
  'YpskxZ': '出库准时率',
  'bqbDVw': '查询',
  'byKmgP': '{start} 至 {end}， 共 {total} 条记录',
  'eZAtxt': '字段展开',
  'fxYWiK': '请输入邮箱',
  'gI0VX4': '准时投递率',
  'gP0n6A': '开头是',
  'gSS3He': '联系人姓名',
  'hOA76J': '等于',
  'lSOSkG': '结尾是',
  'oIbf2X': '上架准时率',
  'pVp/bh': '请选择文件上传',
  'qUKj7E': '复制',
  'r2dEd/': '重置',
  'sIy67M': '包含',
  'uB9dmc': '当前账号暂无<strong>{menuName}</strong>菜单权限，请联系主账号开启',
  'usAYZQ': '最多支持{num}个查询',
  'xUjLTE': '搜索',
  'y5s4nK': '至少输入2个字符',
  'zUjHmW': '<strong>抱歉，没有找到与“{keyword}”相关的文档</strong>{break} 建议您：{break} 看看输入的文字是否有误{break} 去掉可能不必要的字词，如“的”、“什么”等',
  'zbkYlG': '万邑通全场景高效海外{break}卖得好、备得少、综合成本就是少',
  'zkVUHd': '最多查询{num}个，双击切换至单个查询',
  'zvNTfS': '进入指南',
  '+UIRGl': '发票汇总',
  '0AJzSm': '发票税额',
  '1WB+di': '处理异常',
  '2QzYmY': '取消',
  '47GdDb': '关闭',
  '4KPJBi': '文件大小请勿超过{attachmentSizeMax}M，请压缩后上传',
  '4vcHWR': '附件格式/数量:支持格式{attachmentFileFormat},最多上传{attachmentNumMax}个附件,每个附件不超过{attachmentSizeMax}M。(图片上传成功后暂不支持预览功能)',
  '99qdsf': '超期发票金额',
  '9j7Ejw': '上传附件',
  'A64kW0': '最多上传 {maxCount} 个文件',
  'F7+3p7': '发票号',
  'HNFUfF': '请上传附件!',
  'J0D5h+': '开始时间',
  'JN5iZt': '提交成功',
  'PzFarD': '总发票金额',
  'Q06UZa': '发票明细',
  'T8gjTZ': '文件名不能包含空格',
  'U5K9ww': '上传发票',
  'Wy9Mf2': '今天',
  'XQVNb1': '账单区间',
  'YKwdXz': '退回原因',
  'eUSpdN': '查看更多',
  'eydz7g': '应付日期',
  'i0bc3f': '币种',
  'jESlL9': '近{days}天',
  'nEqIuQ': '开票日期',
  'ns1bWF': '请选择账单区间',
  'osngNl': '发票文件',
  'ptv3HC': '流程中发票金额',
  'qaOnvz': '已付款发票金额',
  'qdvxnx': '文件格式限制为{allowExtensions}',
  'r0/TUu': '确定',
  'rLn5dB': '查看明细',
  'sQOTXH': '发票金额',
  'v04auv': '结束时间',
  'v5/qhM': '账单状态',
  '+Y0zrA': '我们向您发送电子邮件以验证您的账户，请检查您的 {email} 收件箱并完成验证{break}如果您未收到邮件，<reSend>点击这里</reSend>请求重新发送',
  '6AJEH3': '新密码',
  '6Y0p2/': '下一步',
  'DQMC7I': '两次密码输入不一致',
  'FEb7U2': '确认',
  'FKnMw9': '确认密码',
  'KOOqT/': '密码修改成功！',
  'Q4T2WD': '此明细列表会展示系统自动识别的发票信息，当识别失败时，无对应明细，会由后台人员进行信息补充',
  'S0RL7L': '忘记密码',
  'S0h9rp': '6-32位数字、字母、标点符号',
  'Vcz4jn': '设置成功',
  'W7shU1': '提供账号信息',
  'YcmSjW': '请输入新密码',
  'Z5Nevj': '修改密码',
  'common.changePwd': '修改密码',
  'eEwaYk': '记得密码？返回<login>登录</login>',
  'f+xVln': '请输入确认密码',
  'gsk33w': '重置密码',
  'hDx3/S': '邮箱',
  'sPM43N': '前往邮箱',
  't0nA+i': '安全验证',
  '4TdPpv': '超期发票金额：状态=审核中、审核不通过、请款中，且已超过应付日期的发票金额合计',
  'LibxI+': '总发票金额：历史至今所有的发票金额合计',
  'hOA0jT': '已付款发票金额：状态=已付款的发票金额合计',
  'zzAMrk': '流程中发票金额：状态=审核中、审核不通过、请款中的发票金额合计',
  '7Op7Wj': '旧密码',
  'TAdFnk': '确认新密码',
  'yTXeo9': '发票管理',
  '4R5GEq': '首页',
  'blEKts': '请输入旧密码',
  '1W7mP7': '阿拉斯加时间',
  'DBKT4U': '供应商',
  'Lu0LkA': '车型',
  'QSV2/G': '订单号',
  'QV3pnn': '状态',
  'R2D5Dv': '创建时间',
  'WNISgN': '美西时间',
  'YJGPnI': '提货点',
  'Yqf2Bb': '运输号',
  'aloI6s': '美东时间',
  'dpTOZD': '车辆中转单',
  'fa/Ner': '夏威夷时间',
  'g+RRVq': '中国标准时间',
  'gQ4+K1': '日期',
  'ghWyE2': '运输单',
  'hCaFQn': '下载凭证',
  'hEQR93': '线路',
  'j05yAV': '美中时间',
  'sSmyfa': '卸货点',
  'vGUm/N': '美山地时间',
  '0mnS/Y': '成功数量:{successNum}, 失败数量:{failNum}, 失败数据文件:{a1}',
  '30EC+P': '申请时间',
  '36+mbi': '处理状态',
  '4W0sU4': '请输入供应商说明',
  '6OSI7c': '查件管理',
  '7XrXMP': '查件备注',
  '8bfXLo': '查件类型',
  'AqMNVt': '批量更新查件结果',
  'BYgheS': '下载文件模板',
  'I/NzUV': '查件结果为“有POD”，需要上传POD才算完结，其他查件结果批量更新后自动完结。',
  'K27qop': '全部导出',
  'MHwPat': '流水号',
  'P0LBOd': '处理',
  'TC+Nuc': 'POD文件',
  'd0xdq1': '查件结果文件',
  'hTgJgQ': '回复时间',
  'mItnls': '附件格式/数量:支持格式{attachmentFileFormat},每个附件不超过{attachmentSizeMax}M。(图片上传成功后暂不支持预览功能)',
  'mZM5AF': '供应商说明',
  'vO6qbO': '查件结果',
  'vxR9vB': '应回复时间',
  'wdC9K4': '查件处理',
  '+P5szr': '长(CM)',
  '/CesoY': '体积(CBM)',
  '/gvpF0': '创建工单',
  '1ccOSo': '承运人',
  '46Zfck': '下载模板',
  '48tTeD': '未校验通过或收货仓库不一致！',
  '6RphVF': '请上传文件',
  '9eOwmI': '工单创建时间',
  'BqZvMO': '确认取消吗？',
  'C3Xyt8': '箱数',
  'C5ShJS': '保存草稿',
  'DN8VBR': '工单结束时间',
  'DtBqz5': '面单/其他文件',
  'DzjlKZ': '请选择预计发货时间',
  'ENPgS/': '提交',
  'I0+bNm': '目的仓',
  'KLv4lM': '新增箱',
  'LURcJh': '说明:',
  'MwjxBM': '重量(KG)',
  'MxxEYf': '收起',
  'OVRt0j': '收货仓库',
  'Qqmpu5': '确定删除吗？',
  'QwslUU': '箱状态',
  'RBartQ': '提交工单',
  'RTQq0d': '装箱信息',
  'RyMWz0': '确认提交吗？',
  'U17oU+': '轨迹',
  'U6zcfC': '出货仓',
  'W5RoYI': '箱流水号/序号',
  'W9LJrj': '箱流水号',
  'Wdmil2': '展开',
  'WlP7ex': '只支持单个查询',
  'XYdT8p': '运输方式',
  'Xhn2gT': '请选择',
  'XmRKnc': '备注',
  'XoAFE4': '导入成功!',
  'aDBVmD': '快递单号',
  'bjzFIC': '预计发货时间',
  'c2y2qR': '导入快递单号',
  'd+Hky2': '宽(CM)',
  'eN8cMr': '重新下单',
  'egpTvD': '编辑工单',
  'fr8qvK': '文件上传成功，请等待数据校验结果',
  'g4ZKwz': '工单状态',
  'gGaW5m': '请输入备注',
  'gRcn+M': '暂无数据，点击上方新增箱',
  'h6fo89': '批量创建工单',
  'k+30OI': '高(CM)',
  'k8/IM8': '供应商退货管理',
  'lnucNJ': '跟踪号',
  'lyzr6E': '双击批量查询',
  'mxWvoh': '根据导入的快递单号自动生成',
  'oH13Vj': '导入',
  'plfeJC': '批量创建工单文件',
  'pyWapc': '发货仓库',
  'qHs28D': '出库单数量',
  'rtmBm+': '1. 导入文件中“*运输方式、发货仓库（名称）、收货仓库（名称）、箱序号”相同默认为同一箱，导入后系统自动生成箱流水号。{break}2. 同一箱的“重量（KG）、长（CM）、宽（CM）、长+宽+高（CM）、预计发货时间”信息必须一致{break}3. 预计发货时间精确到分：（格式示例：2025-08-07 12:25）{break}4. 批呈创建工单为草稿状态，请确认发货地址是否正确后提交。',
  'sk+CM/': '工单号',
  'thGDHR': '多个单号需换行或用英文逗号隔开,最多支持{num}个,双击切换到单个查询',
  'vDCwZ9': '上传文件',
  'vNZuaz': '文件大小请勿超过{attachmentSizeMax}M',
  'vnzzbH': '导出全部',
  'vr5TVT': '请输入',
  'zQ7jgL': '请输入大于0最多2位小数的数字',
  'RPQXYs': '注：指物流跟踪记录',
  'lC02p8': '注：CBM = 立方米，货物体积单位',
  'q5WU4o': '注：“面单”指包含交付详情的运输单据',
  '0fR+fE': 'Route',
  '2mTCCW': 'Current Stop',
  '47FYwb': 'Cancel',
  '5Dzxoy': '不能超过20个字符',
  '7F3IvY': 'Please select',
  '7f7PkF': 'The file format is restricted to {allowExtensions}',
  '8iYIaE': 'The current stop and the next stop cannot be the same',
  'AFBy9/': 'Please take photo of the BOL and upload it',
  'ALwUe0': '填写干线司机信息',
  'BIJUO+': 'Please upload the photos according to the requirements:{break}1) Capture the whole inside of the truck in one picture;{break}2) Confirm that the BOL is correctly filled out and signed',
  'BkXNm/': 'Reconfirm that the arriving time will later than ETA.',
  'BtqAem': 'Departure',
  'Ck/vXW': 'File size should not exceed {attachmentSizeMax}MB. Please compress the file before uploading',
  'Cnjc/E': '司机ID Card',
  'DqjuZJ': 'Please upload the image',
  'DrIKfG': 'You can upload up to {maxCount} files',
  'G/FVOY': '司机姓名',
  'LxCyKX': '请上传',
  'McSzSX': '驾照号',
  'N2IrpM': 'Confirm',
  'P7PLVj': 'Date',
  'PbNtRA': '提交成功!',
  'R86IN4': 'Delay',
  'T46Urg': 'Attachment format/quantity: Supported formats: {attachmentFileFormat}. Maximum uploads: {attachmentNumMax} files. Each attachment must not exceed {attachmentSizeMax}MB.',
  'TP/Uec': 'Capture the whole inside of the truck in one picture and upload it',
  'TfnGaM': 'Next Stop',
  'V9tp+B': 'Please upload the sealed picture with clear seal number',
  'WOIPGx': 'Arrival',
  'b/lR5/': 'Pickup code',
  'hgNsC2': 'arrival',
  'p4N05H': 'Upload',
  'r4ln3K': '不能超过50个字符',
  'vMUomP': 'Upload image',
  'y1K1YT': 'The next stop and the current stop cannot be the same',
  'yy7EDI': '上传',
  'f00p/7': 'Upload failed',
  'hsYvDX': 'Uploading',
  '+Mmw7M': '@2025 BASIC 3PL',
  '3boLWg': 'All events shown at local time',
  '3qvTiX': 'BASIC SHIPPING',
  '3rjr8i': 'More than <remaining></remaining>',
  '4CetJr': 'BASIC SHIPPING TRACKING NUMBER',
  '5JhyC0': '供应商已产生第一条有效轨 or 产生了干线轨迹 且未产生Dscan or RDscan',
  '6aD5NM': 'HIDE DETAILS',
  'ApmjIr': 'DESTINATION',
  'Cl8YLa': 'Only <remaining></remaining> more numbers can be input',
  'F84yRc': 'SHIPMENT DETAILS',
  'GgwgcO': 'SHIPPING SERVICE LEVEL',
  'OWrTNa': '根据跟踪号无法查询到数据或跟踪号对应的订单号的主账户不为18982058 - Basic 3PL, Inc.',
  'QBvgoS': 'TRACKING EVENTS',
  'S0sxA0': '供应商未产生第一条有效轨迹 且 未产生了干线轨迹',
  'UfCLZT': 'CLEAR ALL',
  'a1fAXn': 'STATUS',
  'aG5zxG': 'TRACKING NUMBER',
  'gQRAel': 'Add up to {maxCheckcount} tracking numbers separated by space, rows, commas, or semi-colons.',
  'gSlQXV': 'SHIP FROM LOCATION',
  'kcd/kl': 'LATEST UPDATE',
  'lCtyPk': 'SHIP DATE',
  'oTE2X0': 'Basic Shipping Standard',
  'qZOv9O': 'Basic Shipping Overnight',
  'rfHO5k': 'Basic Shipping Freight',
  'uCR6oy': 'Basic Shipping Economy',
  'uRh9uR': 'Basic Shipping Ground',
  'uUB5hA': '跟踪号产生了Dscan',
  'vdI05h': 'LAST MILE CARRIER',
  'vxuydz': '存在被标记为EXCEPTION类型的轨迹或RDscan',
  'wjT9XY': 'Add up to {count} tracking numbers separated by space, rows, commas, or semi-colons.',
  'xbAmTZ': 'Basic Shipping Express',
  'yLOhiN': 'TRACK',
  'Cpd1nk': '*Basic Shipping provides package tracking services only. For inquiries about order details, please contact Basic 3PL support.',

};
